var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-user-management-grid-wrapper',{attrs:{"values":_vm.values,"airline-lengths":_vm.airlineLengths,"grid-columns":_vm.gridColumns,"grid-filters":_vm.gridFilters,"on-open":_vm.onOpen,"add-user":_vm.addUser,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }